// libs
import { styled } from '@nykaa/ui-components';
import React, { memo } from 'react';

// constants
import { BASE_GUTTER_SPACE } from 'styles/base';

const Text = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.subTitleLarge};
  margin-top: ${BASE_GUTTER_SPACE * 10}px;
  text-align: center;
`;

function NoReviewFound() {
  return <Text data-test="no-review-found">No Review Found</Text>;
}

export default memo(NoReviewFound);
